module.exports = __webpack_public_path__ + "img/app-1.dbfc9ce8.png";